import { supabaseClient } from 'supabase'
import { DeskAlreadyDecidedError } from './deskDecisionError'

export type UndoCandidateParams = {
  id: number
  /**
   * The stamp the decision RPC returned (`desk_reject`, `desk_attach`,
   * `desk_dismiss_match`, `desk_decide_update`), passed back as the exact
   * string PostgREST sent. Never parse it into a Date: that keeps
   * milliseconds only and the undo would never match.
   */
  decidedAt: string
}

/**
 * The toast's Undo (`desk_undo`, review AD-WR-11): the exact inverse of the
 * decision just made, only while the row still carries that stamp. Unlike
 * `desk_restore` it stamps nothing, so a candidate rejected from the Discard
 * pile goes back to the Discard pile and an undone mis-click is not a restore.
 * Returns the tab the candidate is back in.
 *
 * Errors are thrown raw; a null result (stale stamp, decided again, nothing to
 * undo) throws DeskAlreadyDecidedError (D-11).
 */
export const undoCandidate = async ({ id, decidedAt }: UndoCandidateParams): Promise<string> => {
  const { data, error } = await supabaseClient.rpc('desk_undo', {
    p_id: id,
    p_decided_at: decidedAt
  })

  if (error) {
    throw error
  }
  if (typeof data !== 'string' || data === '') {
    throw new DeskAlreadyDecidedError('desk_undo')
  }
  return data
}
